import { useTranslations } from '@vocab/react';
import { Button, IconClear } from 'braid-design-system';
import type { FC } from 'react';

import type { FilterFns } from '../../../components/app/FilterSideBar/useFilters';

import translations from './.vocab';

interface FilterClearButtonProps {
  resetFilters: FilterFns['resetFilters'];
  bleed: boolean;
  showIcon: boolean;
}

export const FilterClearButton: FC<FilterClearButtonProps> = ({
  bleed,
  showIcon,
  resetFilters,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Button
      variant="transparent"
      bleed={bleed}
      onClick={() =>
        resetFilters({
          eventName: 'clear_filters_pressed',
          actionOrigin: 'candidate listing - filter section',
        })
      }
      icon={showIcon ? <IconClear /> : undefined}
    >
      {t('Clear filters')}
    </Button>
  );
};
